export const Icon = ({ name, children, ...rest }) => {
  return (
    <div className={`p-icon p-icon-${name}`} aria-hidden="true" {...rest}>
      <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 40 40">
        {children}
      </svg>
    </div>
  );
};
